import { Navigate, RouteObject } from "react-router-dom";
import EventView from "../pages/Events/EventView";
import NotFound from "../pages/NotFound";

export const eventSpecificRoutes: RouteObject[] = [
    { path: "/events", element: <Navigate to='/' /> },
    { path: "/events/:eventId", element: <EventView /> },
    { path: "/events/:eventId/:imageId", element: <EventView /> },
    { path: "*", element: <NotFound /> },
];
